import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=71fbedf5&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
import style0 from "./Contact.vue?vue&type=style&index=0&id=71fbedf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fbedf5",
  null
  
)

export default component.exports